import { GetChurnRequestsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

type Props = {
  ids?: string[]
}

export const useGetChurnRequests = ({ ids }: Props) => {
  const { data, loading } = useQuery(GetChurnRequestsDocument, {
    variables: {
      ids,
    },
  })

  return {
    loading,
    churnRequests: data?.billing.churnRequests,
  }
}
